import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import '@fortawesome/fontawesome-free/css/all.min.css'

export const Temp_Article: React.FC = () => {


    // Article
    return <div>
        <img className="banner" alt="Zebra EMEA Marketing Concierge" src="https://zebratechnologies.blob.core.windows.net/public/articles/articles_zebra_amea.png" />
        <div className="container-md">
            <h3>
                Potenzia le tue campagne con il servizio Concierge per il marketing EMEA
                <span className="subheading">
                    Accedi a risorse pronte all'uso, framework preconfigurati e supporto di esperti per fare marketing in modo più intelligente e veloce.                </span>
            </h3>

            <p>
                Abbiamo creato il servizio Concierge per il marketing EMEA esclusivamente per i nostri partner Zebra. Ti fornisce gli strumenti per pianificare, lanciare ed eseguire campagne di marketing ad alto impatto con fiducia.
            </p>
            <p>
                Che tu debba generare domanda, supportare la tua pipeline o interagire con specifici settori verticali, il servizio Concierge fornisce campagne, messaggi e materiali pronti all'uso, allineati alle priorità di Zebra, tutti in un unico posto.
            </p>
            <p>
                <strong>Invece di partire da zero, puoi consentire al tuo team di lavorare in modo più efficiente:</strong>
            </p>

            <ul>
                <li>
                    <strong>Accedi a campagne preconfigurate </strong><br />
                    Implementa campagne su misura per settori chiave e casi d'uso specifici.
                </li>
                <li>
                    <strong>Scarica risorse approvate</strong><br />
                    Ottieni messaggi chiari, consigli creativi e indicazioni pratiche
                </li>
                <li>
                    <strong>Allinea il tuo marketing </strong><br />
                    Collega le tue attività direttamente con le soluzioni Zebra e la nostra strategia di accesso al mercato
                </li>
                <li>
                    <strong>Enfasi sui risultati </strong><br />
                    Risparmia tempo, opera in sintonia con il brand e produci risultati aziendali misurabili
                </li>
            </ul>

            <h3>
                Tutto ciò di cui hai bisogno per passare all’azione
                <span className="subheading">
                    All'interno di ogni campagna troverai gli strumenti e le indicazioni per passare rapidamente dall'idea all'esecuzione.                </span>
            </h3>
            <h3>Componenti della campagna </h3>





            <div className="row mb-3">
                <div className="col-12 col-md-6 d-sm-flex mb-3">
                    <div className="card card-dark flex-grow-1">
                        <h3>Panoramica</h3>
                        <hr />Comprendi esattamente a chi è rivolta la campagna e i problemi che risolve.
                    </div>
                </div>

                <div className="col-12 col-md-6 d-sm-flex mb-3">
                    <div className="card card-dark flex-grow-1">
                        <h3>Messaggistica e posizionamento</h3>
                        <hr />Sfrutta chiare proposte di valore, argomenti di discussione ed elementi di prova allineati alle soluzioni Zebra.
                    </div>
                </div>
                <div className="col-12 col-md-6 d-sm-flex mb-3">
                    <div className="card card-dark flex-grow-1">
                        <h3>Pubblico di riferimento e casi d'uso</h3>
                        <hr />Scopri di più su ruoli target, problematiche dei clienti e fattori specifici dei singoli settori verticali.
                    </div>
                </div>
                <div className="col-12 col-md-6 d-sm-flex mb-3">
                    <div className="card card-dark flex-grow-1">
                        <h3>Indicazioni pratiche per l'attivazione</h3><hr />
                        <p>Scopri suggerimenti pratici per canali, tipi di contenuto e tattiche di esecuzione.</p>
                        Grazie a questo approccio pragmatico, diventa più facile produrre un marketing coerente e pertinente, mantenendo al contempo la flessibilità per personalizzare le campagne a livello locale.                    </div>
                </div>
            </div>


            <h3>
                Campagne "Fatte per te"
                <span className="subheading">Hai poco tempo o risorse a disposizione? Lascia che se ne occupino le nostre affidabili agenzie partner.</span>
            </h3>

            <p>Con le nostre campagne "Fatte per te", la tua attività di marketing viene completamente pianificata, creata ed eseguita per tuo conto. Ricevi campagne professionali e coerenti con il brand, senza complicazioni. È un modo semplice e collaborativo per generare domanda e rimanere allineati alle priorità di Zebra, permettendoti di concentrarti su ciò che conta di più.</p>


            <div className="card card-dark flex-grow-1 d-sm-flex mb-3" style={{ "background": "url('/images/zebratechnologies/Zebra EMEA Marketing Concierge - highlight image.png') no-repeat center center / cover" }}>
                <div className="row">
                    <div className="col-md-6">
                        <img src="/images/zebratechnologies/Zebra Concierge Icon.png" alt="Zebra Concierge" width={"75px"} className="img-fluid mb-3" />
                        <h3>Supporto quando ne hai bisogno: Entra in contatto tramite chat</h3>
                        <p>Per rendere l'attivazione della campagna ancora più semplice, usa la chat di Concierge per metterti in contatto direttamente con gli esperti di marketing di Zebra.</p>
                        Accedi rapidamente a informazioni e consigli pratici. Siamo qui per aiutarti a procedere più velocemente, in sintonia con il brand e con la massima fiducia in ogni conversazione con i clienti
                    </div>
                </div>
            </div>
        </div>
    </div>;
};

export default Temp_Article;